window.dataLayer = window.dataLayer || [];

import { clickHandler, determineActionText } from '@/scripts/analytics/analytics.methods';

const eventName = 'bannerPageTitle_tracking';
const actionPropTitle = 'bannerPageTitle_action';
const labelPropTitle = 'bannerPageTitle_label';

const component = document.querySelector('.js-header-banner-ga');
const bannerTitle = component ? component.querySelector('.js-header-banner-title-ga') : null;
let links = [];

function bindEventListener(el) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventName,
      actionProp: actionPropTitle,
      labelProp: labelPropTitle,
      action: `Click ${determineActionText(el)} - ${bannerTitle.innerText}`,
      label: queryURL(el),
    }),
  );
}

function queryURL(el) {
  const url = el.getAttribute('href');
  return url ? url : '';
}

function init() {
  if (!component) {
    return;
  }

  links = [...component.querySelectorAll('a, button')];
  links.forEach(bindEventListener);
}

export default init;
